export * from './ActorFunctionFactoryTermIsNumeric';
